// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"41":"95cc0b97","628":"45126f0e"}[chunkId] + ".js";
};